import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const services = [
  {
    id: 1,
    title: 'Bathrooms',
    description: 'Clean easily with precision of bathroom renovations. From tile work to fixtures, we transform outdated bathrooms into spa-like retreats.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20bathroom%20renovation%20white%20vanity%20walk%20in%20shower%20glass%20door%20warm%20lighting%20clean%20bright%20professional%20interior%20photography%20high%20end%20finishes&width=800&height=600&seq=service-bath-01&orientation=landscape',
    cta: 'Learn More',
  },
  {
    id: 2,
    title: 'Kitchens',
    description: 'Provide a modern kitchen with custom cabinets and countertops. We design and build functional, beautiful kitchens that become the heart of your home.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20kitchen%20remodel%20custom%20white%20cabinets%20granite%20countertops%20stainless%20appliances%20pendant%20lighting%20island%20bright%20clean%20professional%20interior%20photography%20warm%20neutral%20tones&width=800&height=600&seq=service-kitchen-01&orientation=landscape',
    cta: 'Request a Quote',
  },
  {
    id: 3,
    title: 'Handyman',
    description: 'Precision handyman repairs and polished finishes. We\'d never. Contact us and handyman our service.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20handyman%20working%20on%20home%20repair%20tools%20organized%20toolbox%20clean%20work%20environment%20bright%20professional%20photography%20warm%20lighting%20quality%20craftsmanship&width=800&height=600&seq=service-handyman-01&orientation=landscape',
    cta: 'Request a Quote',
  },
];

export default function ServicesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" ref={sectionRef} className="bg-white py-16 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`bg-white rounded-lg overflow-hidden border border-concrete hover:border-teal transition-all duration-500 group ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="h-[200px] md:h-[220px] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6 text-center">
                  <h3 className="font-heading font-bold text-charcoal text-lg mb-3">{service.title}</h3>
                  <p className="font-body text-charcoal/70 text-sm leading-relaxed mb-5">{service.description}</p>
                  <button
                    onClick={service.cta === 'Learn More' ? () => navigate('/gallery') : scrollToContact}
                    className="bg-teal hover:bg-teal-dark text-white font-body text-sm font-semibold px-6 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {service.cta}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}